module.exports = __webpack_public_path__ + "img/007.ba49b071.jpg";